import client from './ApiClient';

function submitPerformanceRating(id, body) {
  const url = `/v1/formal_reviews/assignments/${id}/performance_rating`;
  return client(url, { method: 'PUT', body: body });
}

export { submitPerformanceRating };
